import { State, Action, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';

export interface AppStateModel {
}

@State<AppStateModel>({
    name: 'app',
    defaults: {
    }
})
@Injectable()
export class AppState {

}
